import React from 'react';
import { Button, Icon, Table, Form, Header, Segment, Popup, Loader, Checkbox, Grid } from 'semantic-ui-react';
import axios from 'axios';
import {
    fetchAcademicYears, fetchStudentStatuses,
    fetchStudyCycle,
    fetchStudyType, fetchStudyYears,
} from '../../Lookups/util';

import ReactExport from 'react-data-export';
import ReportExcelFile from './ReportExcelFile';
import { sanitizeExcelDataSet } from '../../util/sanitizeExcel';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from "../../util/PaginationFront";
import {
    additionalFilterSectionStyle,
    checkboxFieldStyle,
    filterFieldGridStyle,
    renderStudentIndicators,
    requiredFilterSectionStyle
} from './reportUiHelpers';

const ExcelFile = ReportExcelFile;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const getStudyTypeAndStatus = (student) => [student.studyTypeName, student.studentStatusName].filter(Boolean).join(' / ');

class EnrolledStudentWithNumberOfPassedCourses extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstTimeEnrolled: false,
            moreThanOnceEnrolled: false,
            studyCycleId: null,
            studyTypeId: null,
            studyYearId: null,
            studentStatusId: null,
            studyProgramSemesterId: null,
            studyProgramBasicId: null,
            semesterId: null,
            organizationalUnitId: null,
            academicYearId: null,

            studyCycles: [],
            studyTypes: [],
            studentStatuses: [],
            studyProgramBasics: [],
            studyProgramBasicsAll: [],
            studyYears: [],
            studyProgramSemesters: [],
            studyProgramSemestersAll: [],

            semesters: [],
            academicYears: [],

            students: [],
            loaded: null,
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            excelData:[],

            exactNumberOfEnrollments: null,
            excludeDroppedOut: false,

            orgUnitFilter: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),


        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.filter = this.filter.bind(this);
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    componentDidMount() {
        let obj = {};
        axios.post(this.state.orgUnitFilter ? 'study-programs/basic/all' : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                console.log('studyProgramBasics', studyProgramBasics);

                this.setState({ studyProgramBasics, studyProgramBasicsAll: studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });

        axios.get('/study-program-semesters')
            .then(res => {
                let studyProgramSemesters = res.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({
                    studyProgramSemesters, studyProgramSemestersAll: studyProgramSemesters
                });
            });

        axios.all([fetchAcademicYears(), fetchStudyCycle(), fetchStudyType(), fetchStudentStatuses(), fetchStudyYears()])
            .then(axios.spread((yearsRes, studyCycleRes, studyTypesRes, studentStatusesRes, studyYearsRes) => {
                const academicYears = yearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                })).reverse();

                const studyCycles = studyCycleRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                const studyTypes = studyTypesRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.displayName
                }));

                let studentStatuses = studentStatusesRes.data.filter(e=> e._key == 'regular' || e._key == 'exchange' || e._key == 'guest' || e._key == 'grad_again').map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));

                if (localStorage.getItem('activeRole').substr(0, 41) !== 'Studentska: Akademija scenskih umjetnosti') {
                    studentStatuses = studentStatuses.filter(el => el._key !== 'gap_year');
                }

                const studyYears = studyYearsRes.data.map(el => ({
                    key: el.id, value: el.id, text: el.name
                }));

                this.setState({
                    studyCycles, studyTypes, studentStatuses, studyYears, academicYears
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch organizationalUnits, studyCycles, languages or academicYears');
            });
    }

    handleInputChange(event, { name, value }) {
        if (value === '') {
            this.setState({
                [name]: null
            });
        }
        this.setState({
            [name]: value
        });

        if (name === 'academicYearId') {
            axios.get(`semester/by-academic-year/${value}`)
                .then(res => {
                    this.setState({
                        semesters: res.data.filter(e => e.name.name !== 'ostalo' && e.name.name !== 'ljetna škola').map(el => ({
                            ...el, key: el.id, value: el.id, text: el.name.name
                        }))
                    });
                });
        }

        if (name === 'studyCycleId') {
            if (value === null) this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll });
            this.setState({ studyProgramBasics: this.state.studyProgramBasicsAll.filter(el => el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].id === value : null) });
        }

        if (name === 'studyYearId') {
            if (value === null) this.setState({ studyProgramSemesters: this.state.studyProgramSemesters });
            axios.get('/study-program-semesters')
                .then(res => {
                    this.setState({
                        studyProgramSemesters: this.state.studyProgramSemestersAll.filter(e => e.studyYear.id === value)
                    });
                });
        }
        if (name === 'studyCycleId' && value === '') { this.setState({ studyCycleId: null, studyProgramBasics: this.state.studyProgramBasicsAll }); }
        if (name === 'studyYearId' && value === '') { this.setState({ studyYearId: null, studyProgramSemesters: this.state.studyProgramSemestersAll }); }
    }

    filter() {
        this.setState({ loaded: false, results: [], activePage: 1 });
        if (!this.state.semester || (this.state.orgUnitFilter && !this.state.organizationalUnitId)) {
            this.setState({ loaded: null });
            return;
        }

        let obj = {
            firstTimeEnrolled: this.state.firstTimeEnrolled,
            moreThanOnceEnrolled: this.state.moreThanOnceEnrolled,
            studyCycleId: this.state.studyCycleId,
            studyTypeId: this.state.studyTypeId,
            studyYearId: this.state.studyYearId,
            studentStatusId: this.state.studentStatusId,
            studyProgramSemesterId: this.state.studyProgramSemesterId,
            studyProgramBasicId: this.state.studyProgramBasicId,
            excludeDroppedOut: this.state.excludeDroppedOut,
            exactNumberOfEnrollments: this.state.exactNumberOfEnrollments === '' ? null :  this.state.exactNumberOfEnrollments
        };
         console.log('obj', obj);

        axios.post(this.state.orgUnitFilter ? `reports/enrolled-in-semester/with-number-of-passed-courses/${this.state.organizationalUnitId}/${this.state.semester}/`
            : `reports/enrolled-in-semester/with-number-of-passed-courses/${this.state.semester}/`, { ...obj })
            .then(res => {
                console.log('res', res.data);
                this.setState({
                    students: res.data, loaded: true,
                    excelData:  res.data.map(el => ([
                        { value: el.lastName},
                        { value: el.firstName},
                        { value: el.fatherName ? el.fatherName : ''},
                        { value: el.index},
                        { value: el.studyCycleName},
                        { value: el.studyProgramBasicName},
                        { value: el.studyProgramName},
                        { value: el.studyYearName},
                        { value: el.studyProgramSemesterName},
                        { value: getStudyTypeAndStatus(el)},
                        { value: el.numberOfCoursesToPass},
                        { value: el.numberOfPassedCourses},
                    ]))
                });
            })
            .catch(err => {
                console.log('Failed to fetch students with number of passed courses.', err);
                this.setState({ students: [], excelData: [], loaded: true });
            });
    }

    getResults(results) {
        if(results.length === 0){
            this.setState({
                excelData:  this.state.students.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.fatherName},
                    { value: el.index},
                    { value: el.studyCycleName},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyYearName},
                    { value: el.studyProgramSemesterName},
                    { value: getStudyTypeAndStatus(el)},
                    { value: el.numberOfCoursesToPass},
                    { value: el.numberOfPassedCourses},
                ]))});
        }
        else{
            this.setState({ results,
                excelData:  results.map(el => ([
                    { value: el.lastName},
                    { value: el.firstName},
                    { value: el.fatherName},
                    { value: el.index},
                    { value: el.studyCycleName},
                    { value: el.studyProgramBasicName},
                    { value: el.studyProgramName},
                    { value: el.studyYearName},
                    { value: el.studyProgramSemesterName},
                    { value: getStudyTypeAndStatus(el)},
                    { value: el.numberOfCoursesToPass},
                    { value: el.numberOfPassedCourses},
                ]))});
        }
        this.handlePaginationChange({}, {activePage: 1})
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.students;
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {

        const numberOfEnrollments = [
            { key: 2, text: '2', value: 2 },
            { key: 3, text: '3', value: 3 },
            { key: 4, text: '4', value: 4 },
            { key: 5, text: '5', value: 5 },
            { key: 6, text: '6', value: 6 },
            { key: 7, text: '7', value: 7 },
            { key: 8, text: '8', value: 8 },
            { key: 9, text: '9', value: 9 },
            { key: 10, text: '10', value: 10 },
        ]

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'Prezime', width: { wpx: 200 } },
                    { title: 'Ime', width: { wpx: 150 } },
                    { title: 'Ime oca', width: { wpx: 150 } },
                    { title: 'Index', width: { wpx: 150 } },
                    { title: 'Ciklus', width: { wpx: 150 } },
                    { title: 'Studijski program', width: { wpx: 200 } },
                    { title: 'NPP', width: { wpx: 250 } },
                    { title: 'Godina studija', width: { wpx: 150 } },
                    { title: 'Semestar studija', width: { wpx: 150 } },
                    { title: 'Tip studiranja / status', width: { wpx: 220 } },
                    { title: 'Broj ispita za položiti', width: { wpx: 150 } },
                    { title: 'Broj položenih ispita', width: { wpx: 150 } },
                ],
                data: this.state.excelData,
            }
        ];

        return (
            <div>
                <Form>
                    <Segment style={requiredFilterSectionStyle}>
                        <Header as="h4" color="blue">Obavezni parametri</Header>
                        <Form.Group widths="equal" style={filterFieldGridStyle}>
                        {this.state.orgUnitFilter && <Form.Field>
                            <Form.Dropdown
                                clearable
                                label="Organizaciona jedinica"
                                placeholder="Organizaciona jedinica"
                                value={this.state.organizationalUnitId}
                                onChange={this.handleInputChange}
                                name="organizationalUnitId"
                                options={this.props.organizationalUnits}
                                search
                                fluid
                                selection
                                error={this.state.organizationalUnitEntityError}
                            />
                        </Form.Field>}
                        <Form.Field>
                            <Form.Dropdown
                                label="Akademska godina"
                                clearable={this.get}
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYearId}
                                onChange={this.handleInputChange}
                                name="academicYearId"
                                options={this.state.academicYears}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field>
                            <Form.Dropdown
                                label="Semestar studija"
                                disabled={!this.state.academicYearId}
                                placeholder="Odaberite semestar studija"
                                options={this.state.semesters}
                                onChange={this.handleInputChange}
                                name="semester"
                                value={this.state.semester}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        {!this.state.orgUnitFilter && <Form.Field />}
                        </Form.Group>
                    </Segment>

                    <Segment style={additionalFilterSectionStyle}>
                        <Header as="h4" color="blue">Dodatni filteri</Header>
                        <Form.Group widths="equal">
                        <Form.Field>
                            <Form.Dropdown
                                label="Ciklus studija"
                                disabled={!this.state.semester}
                                clearable
                                placeholder="Odaberite ciklus"
                                options={this.state.studyCycles}
                                onChange={this.handleInputChange}
                                name="studyCycleId"
                                value={this.state.studyCycleId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <Form.Dropdown
                                label="Studijski program"
                                disabled={!this.state.semester}
                                clearable
                                placeholder="Odaberite studijski program"
                                options={this.state.studyProgramBasics}
                                onChange={this.handleInputChange}
                                name="studyProgramBasicId"
                                value={this.state.studyProgramBasicId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <Form.Dropdown
                                label="Tip studiranja"
                                disabled={!this.state.semester}
                                clearable
                                placeholder="Odaberite tip studiranja"
                                value={this.state.studyTypeId}
                                onChange={this.handleInputChange}
                                name="studyTypeId"
                                options={this.state.studyTypes}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        </Form.Group>

                        <Form.Group widths="equal">
                        <Form.Field>
                            <Form.Dropdown
                                label="Status studenta"
                                disabled={!this.state.semester}
                                clearable
                                placeholder="Odaberite status"
                                value={this.state.studentStatusId}
                                onChange={this.handleInputChange}
                                name="studentStatusId"
                                options={this.state.studentStatuses}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field>
                            <Form.Dropdown
                                label="Godina studija"
                                disabled={!this.state.semester}
                                clearable
                                placeholder="Odaberite godinu studija"
                                options={this.state.studyYears}
                                onChange={this.handleInputChange}
                                name="studyYearId"
                                value={this.state.studyYearId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                        <Form.Field>
                            <Form.Dropdown
                                label="Semestar studija"
                                disabled={!this.state.semester}
                                clearable
                                placeholder="Odaberite semestar studija"
                                options={this.state.studyProgramSemesters}
                                onChange={this.handleInputChange}
                                name="studyProgramSemesterId"
                                value={this.state.studyProgramSemesterId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        </Form.Group>

                        <Form.Group inline>
                            <Form.Field style={checkboxFieldStyle}>
                            <Checkbox
                                disabled={!this.state.semester}
                                checked={this.state.firstTimeEnrolled}
                                label="Samo prvi put upisani"
                                value={this.state.firstTimeEnrolled}
                                onChange={(e) => this.setState({ firstTimeEnrolled: !this.state.firstTimeEnrolled, moreThanOnceEnrolled: false, exactNumberOfEnrollments: null })}
                            />
                            </Form.Field>
                            <Form.Field style={checkboxFieldStyle}>
                            <Checkbox
                                disabled={!this.state.semester}
                                checked={this.state.moreThanOnceEnrolled}
                                label="Samo ponovci"
                                value={this.state.moreThanOnceEnrolled}
                                onChange={(e) => this.setState({ moreThanOnceEnrolled: !this.state.moreThanOnceEnrolled, firstTimeEnrolled: false })}
                            />
                            </Form.Field>
                            <Form.Field style={checkboxFieldStyle}>
                                <Checkbox
                                    disabled={!this.state.semester}
                                    checked={this.state.excludeDroppedOut}
                                    label="Isključi ispisane"
                                    value={this.state.excludeDroppedOut}
                                    onChange={() => this.setState({ excludeDroppedOut: !this.state.excludeDroppedOut })}
                                />
                            </Form.Field>
                        </Form.Group>

                        { this.state.moreThanOnceEnrolled &&
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <Form.Dropdown
                                        clearable
                                        label="Broj upisa"
                                        placeholder="Broj upisa"
                                        options={numberOfEnrollments}
                                        onChange={this.handleInputChange}
                                        name="exactNumberOfEnrollments"
                                        value={this.state.exactNumberOfEnrollments}
                                        search
                                        selection
                                        floating
                                    />
                                </Form.Field>
                                <Form.Field />
                                <Form.Field />
                            </Form.Group>
                        }
                    </Segment>


                    <Button disabled={!this.state.semester} basic="true" color="blue" floated="right" onClick={this.props.closeReport}>Odustani</Button>
                    <Button disabled={!this.state.semester || (this.state.orgUnitFilter && !this.state.organizationalUnitId)} color="blue" floated="right" onClick={this.filter}>Prikaži izvještaj
                    </Button>

                </Form>
                <br /><br /><br />
                {this.state.loaded === false ? <div><Loader active inline="centered" > Učitavanje podataka može potrajati, molimo da sačekate.</Loader><br /><br /><br /></div> :
                    this.state.loaded &&
                    <div>

                        {this.state.students.length ? <Table celled selectable compact>

                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={20} >
                                        <Grid column={2} stackable>
                                            <Grid.Column width={14}>
                                                <SearchTableData profMozilla data={this.state.students} getResults={this.getResults} filterItem={['numberOfCoursesToPass', 'numberOfPassedCourses', 'lastName', 'firstName', 'fatherName', 'index', 'studyProgramSemesterName', 'studyCycleName', 'studyProgramBasicName', 'studyProgramName', 'studyTypeName', 'studentStatusName']} />
                                            </Grid.Column>
                                            <Grid.Column width={2} textAlign="center">
                                                <ExcelFile filename="Upisani studenti sa brojem položenih predmeta" element={<Popup
                                                    trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                        <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                        <Button.Content visible>
                                                            Excel
                                                        </Button.Content>
                                                    </Button>}
                                                    content="Preuzmi spisak u Excel-u"
                                                    hideOnScroll
                                                    position="top center"
                                                />}>
                                                    <ExcelSheet dataSet={sanitizeExcelDataSet(multiDataSet)} name="Studenti" />
                                                </ExcelFile>
                                            </Grid.Column>
                                        </Grid>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell width="1">  R.br. </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={3}>Prezime (ime oca) ime</Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Index </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Ciklus </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Studijski program </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> NPP </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Godina studija </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Semestar studija </Table.HeaderCell>
                                    <Table.HeaderCell colSpan={2}> Tip studiranja </Table.HeaderCell>
                                    <Table.HeaderCell> Broj ispita za položiti </Table.HeaderCell>
                                    <Table.HeaderCell> Broj položenih ispita </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {currentPosts.map((el, index) =>
                                (<Table.Row positive={el.numberOfCoursesToPass === el.numberOfPassedCourses} key={el.id}>

                                    <Table.Cell verticalAlign="middle" width="1">  {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}. </Table.Cell>
                                    <Table.Cell colSpan={3} verticalAlign="middle" > {el.lastName} ({el.fatherName}) {el.firstName}{renderStudentIndicators(el)}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.index}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyCycleName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyProgramBasicName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyProgramName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyYearName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" > {el.studyProgramSemesterName}</Table.Cell>
                                    <Table.Cell colSpan={2} verticalAlign="middle" >
                                        <div>{el.studyTypeName}</div>
                                        {el.studentStatusName && <div style={{ color: '#767676', fontSize: '0.9em' }}>{el.studentStatusName}</div>}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.numberOfCoursesToPass}</Table.Cell>
                                    <Table.Cell verticalAlign="middle" > {el.numberOfPassedCourses}</Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table> : 'Nema podataka.'}
                        {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                    </div>}

            </div>
        );
    }
}

export default EnrolledStudentWithNumberOfPassedCourses;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/EnrolledStudentWithNumberOfPassedCourses.js